import { createAction } from 'typesafe-actions';
import { TUser } from 'modules/user';

//액션 타입 선언
export const SET_USER_INFO = 'users/SET_USER_INFO' as const;

//액션 생성 함수 선언
export const setUserInfo = createAction(SET_USER_INFO)<TUser>();
